import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setFormDateErrorCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getFormDateErrorCount() {
            return HTTP.get('/kenya/form_dates/get_error_count');
        }
    },
}